<template>
  <component :is="layoutComponent" />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter();

const layoutComponent = computed(() => {
  const { meta: { layout } } = router.currentRoute.value;
  return layout || 'GuestLayout';
});

</script>

<style lang="postcss">
/* App.vue */
#app {
  @apply h-full w-full text-base text-gray-900 dark:text-white
  bg-gray-100 dark:bg-gray-900 antialiased;
  font-family: 'Inter', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* Improve transitions on theme change or interactive elements */
body,
html {
  @apply transition-colors duration-300 ease-in-out;
}

/* Scrollbar styling (optional) */
::-webkit-scrollbar {
  width: 6px;
}
::-webkit-scrollbar-thumb {
  background-color: rgba(107, 114, 128, 0.5); /* Tailwind's gray-500 with opacity */
  border-radius: 3px;
}
</style>
